import React from "react"

import { Input } from "@coval/ui/input"

import type { MetricRecordData } from "@/types/metrics/contracts"

import {
  FIELD_CONTAINER_STYLES,
  LABEL_ROW_STYLES,
  LABEL_STYLES,
} from "../styles"
import { RequiredMarker } from "./RequiredMarker"
import {
  TargetFilterToggle,
  type TargetFilterValueType,
} from "./TargetFilterToggle"

interface MetadataFieldConfigProps {
  metricRecordData: MetricRecordData
  onChange: (metric: MetricRecordData) => void
}

export const MetadataFieldConfig: React.FC<MetadataFieldConfigProps> = ({
  metricRecordData,
  onChange,
}) => {
  const fieldKeyId = React.useId()
  const targetFilterValueType: TargetFilterValueType | undefined = {
    BOOLEAN: "boolean",
    FLOAT: "numerical",
    NUMBER: "numerical",
    STRING: "string",
  }[metricRecordData.metric_metadata?.metadata_field_type || ""] as
    | TargetFilterValueType
    | undefined

  const handleFieldKeyChange = (value: string) => {
    onChange({
      ...metricRecordData,
      metric_metadata: {
        ...metricRecordData.metric_metadata,
        metadata_field_key: value,
      },
    })
  }

  return (
    <div className="space-y-6">
      <div className={FIELD_CONTAINER_STYLES}>
        <div className={LABEL_ROW_STYLES}>
          <label htmlFor={fieldKeyId} className={LABEL_STYLES}>
            Field Key
            <RequiredMarker />
          </label>
        </div>
        <Input
          id={fieldKeyId}
          aria-label="Field Key"
          value={metricRecordData.metric_metadata?.metadata_field_key || ""}
          onChange={(e) => handleFieldKeyChange(e.target.value)}
          placeholder="The key to extract from metadata (e.g., duration, score)"
        />
      </div>
      {targetFilterValueType && (
        <TargetFilterToggle
          metricRecordData={metricRecordData}
          onChange={onChange}
          valueType={targetFilterValueType}
        />
      )}
    </div>
  )
}
